import { getAction } from "@/api/manage";
import { mixinDevice } from "@/utils/mixin.js";
export default {
  mixins: [mixinDevice],
  data: function data() {
    return {
      courseInfo: {},
      treeData: [],
      src: '',
      currentMedia: {},
      player: null,
      videoOptions: {
        preload: true,
        autoplay: true,
        controls: true,
        //用户可以与之交互的控件
        loop: false,
        //视频一结束就重新开始
        muted: false,
        //默认情况下将使所有音频静音
        // aspectRatio: '16:9', //显示比率
        fullscreen: {
          // options: { navigationUI: 'hide' },
        },
        sources: [{}]
      }
    };
  },
  mounted: function mounted() {
    // this.initPlayer()
  },
  beforeDestroy: function beforeDestroy() {
    this.player.dispose();
  },
  watch: {
    currentMedia: {
      deep: true,
      handler: function handler(newval) {
        console.log(newval);
        window.p = this.player;
        this.player.ended();
        this.player.src(newval.path);
        this.player.play();
      }
    },
    $route: function $route(to, from) {
      var courseId = this.$route.query.id;
      this.getCourseInfo(courseId);
      this.getCourseUnitTree(courseId);
    }
  },
  created: function created() {
    var courseId = this.$route.query.id;
    this.getCourseInfo(courseId);
    this.getCourseUnitTree(courseId);
  },
  methods: {
    getCourseInfo: function getCourseInfo(courseId) {
      var _this = this;
      getAction("/teaching/teachingCourse/get?id=" + courseId).then(function (res) {
        _this.courseInfo = res.result;
      });
    },
    getCourseUnitTree: function getCourseUnitTree(courseId) {
      var _this2 = this;
      getAction("/teaching/teachingCourseUnit/showCourseUnitTree?courseId=" + courseId).then(function (res) {
        _this2.treeData = res;
        _this2.initPlayer();
        _this2.selectFirst();
      });
    },
    initPlayer: function initPlayer() {
      this.player = this.$video(this.$refs.videoPlayer, this.videoOptions, function onPlayerReady() {
        this.on('error', function () {
          //this.errorDisplay.close_() //将错误信息不显示
        });
        this.on('canplaythrough', function () {});
      });
    },
    selectFirst: function selectFirst() {
      if (this.treeData) {
        this.currentMedia = this.treeData[0].children[0];
      }
    },
    onSelect: function onSelect(key, e) {
      var media = this.getTreeItem(key[0]);
      if (media) {
        this.currentMedia = media;
      }
      //使课程浏览次数+1
      this.getCourseInfo(this.$route.query.id);
    },
    getTreeItem: function getTreeItem(key) {
      for (var i in this.treeData) {
        var n1 = this.treeData[i];
        if (n1.children) {
          for (var j in n1.children) {
            if (key == n1.children[j].key) {
              return n1.children[j];
            }
          }
        }
      }
    }
  }
};